import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { walletsBunja } from '@flipster/r230522/original/wallet';
import Num from '@flipster/utils/num';

import { rawCurrenciesKeyByCurrencyAtom, rawInstrumentsKeyBySymbolAtom } from '../snapshot/state';

export const useSpotHoldings = () => {
  const { walletsAtom } = useBunja(walletsBunja);
  const wallet = useAtomValue(walletsAtom);
  const currenciesKeyByCurrency = useAtomValue(rawCurrenciesKeyByCurrencyAtom);
  const instrumentsKeyBySymbol = useAtomValue(rawInstrumentsKeyBySymbolAtom);
  const spotInstruments = Object.entries(instrumentsKeyBySymbol || {}).filter(([, value]) => value.isSpot);

  const holdings = Object.entries(wallet || {})
    .filter(([key, value]) => {
      const c = currenciesKeyByCurrency?.[key];
      if (!c) return false;
      if (c.isBonus || c.isUSDT) return false;
      const spotInstrument = spotInstruments.find(([, spotValue]) => spotValue.baseCurrency === key);
      if (!spotInstrument) return false;
      const [, spotValue] = spotInstrument;
      if (Num(value.walletBalanceExclWithdrawalPending).isLessThan(spotValue.unitOrderQty)) return false;
      return !Num(value.walletBalanceExclWithdrawalPending).isZero();
    }, [])
    .sort(([ac, aw], [bc, bw]) => {
      // 자산순으로 정렬
      const minus = Num(bw.walletBalanceExclWithdrawalPendingInUsdt).minus(aw.walletBalanceExclWithdrawalPendingInUsdt);
      if (!minus.isZero()) return minus.toNumber();
      return ac.localeCompare(bc);
    });

  return { holdings };
};
